'use strict';

const dates = require('util/dates');
const isEqual = require('lodash/isEqual');
const map = require('lodash/map');

function controller($attrs, $scope, $timeout, plannerService) {
    const vm = this;

    const prodSeasonNo = parseInt($attrs.prodSeasonNo, 10);
    const perfNo = parseInt($attrs.perfNo, 10);
    const isFOV = !!$attrs.isFov;
    const filterDate = $attrs.dateFilter && $attrs.dateFilter !== 'all' ? $attrs.dateFilter : false;
    const showSingleButtonProduction = $attrs.showSingleButtonProductionList ? $attrs.showSingleButtonProductionList.split(',') : [];
    let allResults = [];
    let allFilters = null;
    let updating = false;

    let startDate = dates.moment($attrs.startDate)
    let endDate = dates.moment($attrs.endDate)

    vm.loading = true;
    vm.errorLoading = false;

    vm.items = [];
    vm.perfs = [];
    vm.filters = null;

    vm.init = function () {
        plannerService.getPerformances().then(performances => {
            let filterFn;
            performances = performances.filter(p => p.show_in_listing);

            if (isFOV) {
                filterFn = (p) => p.fov;
            } else if (perfNo) {
                filterFn = (p) => parseInt(p.perf_no) === perfNo;
            } else {
                filterFn = (p) => parseInt(p.prod_season_no, 10) === prodSeasonNo;
            }
            if (filterFn) {
                allResults = performances.filter(filterFn);
            } else {
                allResults = performances;
            }

            if (filterDate) {
                const dt = dates.moment(filterDate);
                allResults = allResults.filter(p => p.end_date_moment.isSame(dt, 'day'));
            } else {
                if ($attrs.startDate) {
                    allResults = allResults.filter(perf => {
                        return perf.start_date_moment.isSameOrAfter(startDate, 'day');
                    })
                }

                if ($attrs.endDate) {
                    allResults = allResults.filter(perf => {
                        return perf.end_date_moment.isSameOrBefore(endDate, 'day');
                    })
                }
            }


            // With the results, also generate filters
            allFilters = plannerService.generateFacets(allResults);

            // updateView straight away
            updateView(allResults);

            // Get a watcher going on keyword input & filters
            $scope.$watch(() => [vm.filters], processChanges, true);

            // Get a watcher going on location search
            $scope.$watch(() => location.search, processLocation);

        }, e => {
            console.log(e);

            vm.errorLoading = true;
        }).catch( e => {
            console.log(e);

            vm.errorLoading = true;
        }).finally(function () {
            vm.loading = false;
        });
    }

    vm.clearAll = function () {
        vm.filters = map(vm.filters, filter => {
            filter.keywords = map(filter.keywords, keyword => {
                keyword.checked = false;

                return keyword;
            });

            return filter;
        });
    }

    vm.getImageUrl = function (perf, width, height, crop) {
        return perf.image_url
            .replace(/w_\d+/, `w_${width}`)
            .replace(/h_\d+/, `h_${height}`)
            .replace(/c_\d+/, `c_${crop}`);
    }

    function applyFiltering(filters, updateLocation) {
        // Keep track is updating to prevent watch firing
        updating = true;

        // Now, apply filters
        const result = plannerService.applyFilters({
            filters: filters,
            items: allResults
        });

        // Update location search on first load
        if (updateLocation) {
            plannerService.updateLocation(null, result.facets, null);
        }

        // Update view :3
        updateView(result.items, result.facets);
    }

    function processChanges(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (vm.loading || isEqual(newVal, oldVal) || updating) {
            return false;
        }

        applyFiltering(newVal[0], true);
    }

    function processLocation(newVal, oldVal) {
        // Skip when loading, same values, or updating
        if (vm.loading || isEqual(newVal, oldVal) || updating) {
            return false;
        }

        // Figure out what we need to filter!
        const locationFacets = plannerService.locationFacets(vm.filters, true);

        // Use that to apply our filtering
        applyFiltering(locationFacets.filters, false);
    }

    function updateView(items, facets) {
        // Keep track is updating to prevent watch firing
        updating = true;

        // Grab count before grouped
        vm.totalCount = items.length;

        const showMultiplePerformancesAsOne = showSingleButtonProduction.includes(String(items[0].prod_season_no));
        const isWelshPage = document.location.pathname.toString().indexOf("/cy/") === 0;

        if (showMultiplePerformancesAsOne) {
            if (isWelshPage) {
                items[0].date_display = `O ${items[0].date_display}`
            } else {
                items[0].date_display = `From ${items[0].date_display}`
            }
            items[0].forced_date_description = true;
        }

        // Expose grouped items
        vm.items = plannerService.groupByDay(items);
        vm.perfs = showMultiplePerformancesAsOne ? [items[0]] : items;

        // Reset updating flag
        $timeout(function () {
            updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$attrs', '$scope', '$timeout', 'plannerService', controller
];



// WEBPACK FOOTER //
// ./widgets/controllers/PerformanceList.js